import React, { useState, useEffect } from "react";
import AddEntryForm from "../components/AddEntryForm";
import EditEntryForm from "../components/EditEntryForm";
import EntryList from "../components/EntryList";
import Modal from "../components/Modal";
import "../styles/AdminDashboard.css";
import RaiseAdminFrom from "../components/RaiseAdminForm";
import { APIBaseLink } from "../components/APIBaseLink";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { validateSearchTerm } from "../components/RegExs";

const AdminDashboard = () => {
	const [entries, setEntries] = useState([]);
	const [editingEntry, setEditingEntry] = useState(null);
	const [showAddModal, setShowAddModal] = useState(false); // State for Add Entry Modal
	const [showPromotion, setShowPromotion] = useState(false); // State for Add Entry Modal
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [isSearching, setIsSearching] = useState(false);
	const [error, setError] = useState("");
	const userToken = localStorage.getItem("token");
	const [showCreateAdminModal, setShowCreateAdminModal] = useState(false); // State for Create Admin Modal
	const [createAdminData, setCreateAdminData] = useState({
		email: "",
		firstName: "",
		lastName: "",
		username: "",
		mfa: false,
	});

	const [selectedFilter, setSelectedFilter] = useState("");

	const API_BASE_LINK = APIBaseLink();

	useEffect(() => {
		if (isSearching) {
			fetchSearchResults();
		} else {
			fetchAllEntries();
		}
	}, [currentPage]);

	useEffect(() => {
		if (selectedFilter) {
			fetchSearchResults();
		}
	}, [currentPage, selectedFilter]);

	const fetchAllEntries = async () => {
		const obj = { page: currentPage, limit: "10" };
		try {
			const response = await fetch(API_BASE_LINK + "/resource/getAllResources", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(obj),
			});
			const data = await response.json();
			//console.log(data); //debug
			setEntries(data.results);
			setTotalPages(data.totalPages);
		} catch (error) {
			console.error("Error fetching entries:", error);
		}
	};

	const handleFilterClick = (filter) => {
		const newFilter = selectedFilter === filter ? "" : filter;
		setSelectedFilter(newFilter);

		if (newFilter === "") {
			handleStopSearch();
		} else {
			setIsSearching(true);
		}
	}; // toggle filters on or off

	const handleEdit = (entry) => {
		setEditingEntry(entry);
	};

	const handleButtonClick = () => {
		setShowAddModal(true); // Show Add Entry Modal
	};

	const handlePromotionClick = () => {
		setShowPromotion(true); // Show Promotion Modal
	};

	const handleDelete = async (id) => {
		const confirmed = window.confirm("Are you sure you want to delete this entry?");
		if (confirmed) {
			try {
				await fetch(`${API_BASE_LINK}/resource/deleteResource/${id}`, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${userToken}`,
					},
				});
				console.log("Entry deleted!");
				toast.success("Entry Deleted.");
				fetchAllEntries();
			} catch (error) {
				console.error("Error deleting entry:", error);
				toast.error("Error Deleting Entry.");
			}
		}
	};

	const handleSave = async (updatedEntry) => {
		console.log("Entry updated!");
		try {
			await fetch(`${API_BASE_LINK}/resource/updateResource/${updatedEntry._id}`, {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userToken}`,
				},
				body: JSON.stringify(updatedEntry),
			});
			// console.log(updatedEntry);
			setEditingEntry(null);
			toast.success("Resource Changes Saved Successfully.")
			// fetchAllEntries();
			fetchSearchResults();

		} catch (error) {
			console.error("Error updating entry:", error);
		}
	};

	// Adds a new entry from the Add Entry From
	const handleAdd = (formData) => {
		console.log("Form Data :", formData); // Submitted Form Information

		// Checks if all required fields are entered
		let check = true;
		// check = Object.keys(formData).every((key) => {
		// 	//If current Key is not an optional field
		// 	if (
		// 		key !== "Services" &&
		// 		key !== "Eligibility_Requirement" &&
		// 		key !== "How_To_Apply" &&
		// 		key !== "Rating" &&
		// 		key !== "adminNotes" &&
		// 		key !== "Date_Uploaded"
		// 	) {
		// 		// if key is empty
		// 		if (formData[key] === "" || formData[key] == [] || formData[key].length == 0) {
		// 			console.log(`Incomplete Form: ${key} is missing`);
		// 			setMessage({
		// 				type: "error",
		// 				text: `${key} is missing`,
		// 			});
		// 			setTimeout(() => setMessage(null), 3000);
		// 			return false;
		// 		} else {
		// 			return true;
		// 		}
		// 	} else {
		// 		return true;
		// 	}
		// });

		if (check) {
			try {
				fetch(API_BASE_LINK + "/resource/addResource", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${userToken}`,
					},
					body: JSON.stringify(formData),
				})
					.then((response) => response.json())
					.then((data) => {
						//console.log("Entry added!");
						setShowAddModal(false); // Close Add Entry Modal
						fetchAllEntries();
					});
				console.log("Entry added!");
				toast.success("Entry Added Successfully.");
			} catch (error) {
				console.error("Error adding entry:", error);
				toast.error("Error Adding Entry");
			}
		}
	};

	const filteredEntries = entries.filter((entry) => entry.Name.toLowerCase().includes(searchTerm.toLowerCase()));

	const handlePreviousPage = () => {
		if (currentPage > 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			setCurrentPage(currentPage + 1);
		}
	};

	const handleCancel = () => {
		setShowAddModal(false); // Close Add Entry Modal
	};

	const handlePromotionCancel = () => {
		setShowPromotion(false); // Close Add Entry Modal
	};
	//debug
	const handleSearchClick = () => {
		setSelectedFilter("");
		setIsSearching(true);
		setCurrentPage(1); //fix current page
		fetchSearchResults();
	};

	const handleStopSearch = () => {
		setIsSearching(false);
		setSearchTerm("");
		setSelectedFilter("");
		setCurrentPage(1); //fix current page
		setError("");
		fetchAllEntries();
	};

	const fetchSearchResults = async () => {
		setError("");
		const termToSearch = selectedFilter || searchTerm;
		console.log("Searching: ", termToSearch);
		if(validateSearchTerm(termToSearch)) {
			try {
				const response = await fetch(API_BASE_LINK + "/resource/search", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						searchTerm: termToSearch,
						page: currentPage,
					}),
				});
				if (!response.ok) {
					// setError("No Results Found.");
					toast.error("No Results Found.");
					return;
				}
				const data = await response.json();
				//console.log(data);
				setEntries(data.results);
				setTotalPages(data.totalPages);
			} catch (error) {
				console.error("Error fetching entries:", error);
				toast.error("Error Fetching Entries");
			}
		} else {
			setIsSearching(false);
		}
	};

	const handleCreateAdmin = async (e) => {
		e.preventDefault();
		try {
			const response = await fetch(API_BASE_LINK + "/user/newAdmin", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userToken}`,
				},
				body: JSON.stringify(createAdminData),
			});
			const data = await response.json();
			if (response.ok) {
				toast.success("Admin Created Successfully.");
				setShowCreateAdminModal(false);
			} else {
				toast.error("Error Creating Admin.");
				console.log(data.message || "Failed to create admin.");
			}
		} catch (error) {
			toast.error("An Error Occured.");
		}
	};

	const handleRaiseToAdmin = async (formData) => {
		// e.preventDefault();
		try {
			const response = await fetch(API_BASE_LINK + "/user/promoteToAdmin", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${userToken}`,
				},
				body: JSON.stringify(formData),
			});
			const data = await response.json();
			if (response.ok) {
				toast.success("Account Promoted Successully");
				setShowPromotion(false);
			} else {
				toast.error("Failed To Promote Account");
			}
		} catch (error) {
			toast.error("An Error Occured");
		}
	};

	return (
		<div className="admin-dashboard">
			<h1>Admin Dashboard</h1>

			<div className="search-bar">
				<input type="text" 
				placeholder="Search Services" 
				value={searchTerm} 
				onChange={(e) => setSearchTerm(e.target.value)} 
				onKeyDown={(e) => e.key === "Enter" && handleSearchClick()} //makes it so when enter key is pressed, the inptu is submitted
				/>
				<button onClick={handleSearchClick}>Search</button>
				<div></div>
				<div className="back-to-results">
					<button onClick={handleStopSearch}>Refresh</button>
				</div>
			</div>
			{error && <p style={{ color: "red" }}>{error}</p>}
			<div className="filter-tags">
				{["Food", "Housing", "Transit", "Utilities", "Health", "Money", "Education", "Work", "Legal", "More"].map((filter) => (
					<div key={filter} className={`tag ${selectedFilter === filter ? "active" : ""}`} onClick={() => handleFilterClick(filter)}>
						{filter}
					</div>
				))}
				<div className="clear-filters" onClick={handleStopSearch}>
					Clear All Filters
				</div>
			</div>

			<div className="button-group">
				<div className="add-entry">
					<button className="action-button" onClick={handleButtonClick}>
						Add Entry
					</button>
					<Modal isOpen={showAddModal} onClose={handleCancel}>
						<AddEntryForm onSubmit={handleAdd} onCancel={handleCancel} />
					</Modal>
				</div>
				<div className="promote-account">
					<button className="action-button" onClick={handlePromotionClick}>
						Promote to Admin
					</button>
					<Modal isOpen={showPromotion} onClose={handlePromotionCancel}>
						<RaiseAdminFrom onSubmit={handleRaiseToAdmin} onCancel={handlePromotionCancel} />
					</Modal>
				</div>
				<div className="create-admin">
					<button className="action-button" onClick={() => setShowCreateAdminModal(true)}>
						Create Admin
					</button>
					<Modal isOpen={showCreateAdminModal} onClose={() => setShowCreateAdminModal(false)}>
						<h2>Create New Admin</h2>
						<form onSubmit={handleCreateAdmin}>
							<div className="form-group">
								<label>Username:</label>
								<input
									type="text"
									value={createAdminData.username}
									onChange={(e) =>
										setCreateAdminData({
											...createAdminData,
											username: e.target.value,
										})
									}
									required
								/>
							</div>
							<div className="form-group">
								<label>First Name:</label>
								<input
									type="text"
									value={createAdminData.firstName}
									onChange={(e) =>
										setCreateAdminData({
											...createAdminData,
											firstName: e.target.value,
										})
									}
									required
								/>
							</div>
							<div className="form-group">
								<label>Last Name:</label>
								<input
									type="text"
									value={createAdminData.lastName}
									onChange={(e) =>
										setCreateAdminData({
											...createAdminData,
											lastName: e.target.value,
										})
									}
									required
								/>
							</div>
							<div className="form-group">
								<label>Email:</label>
								<input
									type="email"
									value={createAdminData.email}
									onChange={(e) =>
										setCreateAdminData({
											...createAdminData,
											email: e.target.value,
										})
									}
									required
								/>
							</div>
							<button type="submit" className="action-button">
								Create Admin
							</button>
						</form>
					</Modal>
				</div>
			</div>

			{isSearching && <div className="results-title">
				<h3>Entry Results</h3>
			</div>}
			{isSearching && <div className="results">
				{entries.length > 0 ? (
					entries.map((entry, index) => <EntryList key={index} entry={entry} onEdit={handleEdit} onDelete={handleDelete} />)
				) : (
					<p>No results found</p>
				)}
			</div>}

			{isSearching && <div className="pagination">
				<button className="navButtons" onClick={handlePreviousPage} disabled={currentPage === 1}>
					Previous
				</button>
				<span>
					Page {currentPage} of {totalPages}
				</span>
				<button className="navButtons" onClick={handleNextPage} disabled={currentPage === totalPages}>
					Next
				</button>
			</div>}

			{/* Record Ownership is not enforced */}
			<Modal isOpen={!!editingEntry} onClose={() => setEditingEntry(null)}>
				{editingEntry && <EditEntryForm entry={editingEntry} onSave={handleSave} onCancel={() => setEditingEntry(null)} />}
			</Modal>
		</div>
	);
};

export default AdminDashboard;
